fragment TenantFragment on Tenant {
    id
    endpoint
    type
    subscription_plan
    subscription_status
    subscription_offer
    subscription {
        id
        offer_key
        product_key
        plan
        status
        provider
        provider_customer_id
        provider_subscription_id
        starts_at
        trial_ends_at
        current_period_ends_at
        ends_at
        limits
        metadata
    }
    subscriptions {
        id
        offer_key
        product_key
        plan
        status
        provider
        provider_customer_id
        provider_subscription_id
        starts_at
        trial_ends_at
        current_period_ends_at
        ends_at
        limits
        metadata
    }
    active_modules
    modules {
        id
        module_key
        status
        plan
        starts_at
        ends_at
    }
    trial_started_at
    trial_ends_at
    trial_expired
    trial_product
    requires_upgrade
    upgrade_url
}
